import { Directive, effect, forwardRef, inject, Injectable, input } from '@angular/core';
import { AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { map } from 'rxjs/operators';
import { from, Observable } from 'rxjs';
import { ReportsService } from '../../services/reports.service';

@Directive({
  selector: '[appUniqueReportName]',
  providers: [{ provide: NG_ASYNC_VALIDATORS, useExisting: forwardRef(() => UniqueReportNameValidatorDirective), multi: true }],
})
export class UniqueReportNameValidatorDirective implements AsyncValidator {
  private readonly validator = inject(UniqueReportNameValidator);
  readonly reportId = input<number | undefined>(undefined, { alias: 'appUniqueReportName' });

  private onValidatorChange?: () => void;

  constructor() {
    effect(() => {
      this.reportId();
      this.onValidatorChange?.();
    });
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onValidatorChange = fn;
  }

  validate(control: AbstractControl): Observable<ValidationErrors | null> {
    return this.validator.validate(control, this.reportId());
  }
}

@Injectable({ providedIn: 'root' })
export class UniqueReportNameValidator implements AsyncValidator {
  private readonly reportsService = inject(ReportsService);

  validate(control: AbstractControl, reportId?: number): Observable<ValidationErrors | null> {
    const reportName = String(control.value ?? '');

    return from(this.reportsService.isReportNameUsed(reportName, reportId)).pipe(
      map(isUsed => isUsed ? { uniqueReportName: true } : null)
    );
  }
}
